(() => {
  const initCarousel = (root) => {
    if (!root || root.dataset.carouselInitialized === 'true') return;

    const viewport = root.querySelector('[data-moment-carousel-viewport]');
    const previous = root.querySelector('[data-moment-carousel-prev]');
    const next = root.querySelector('[data-moment-carousel-next]');

    if (!viewport) return;

    const scrollByPage = (direction) => {
      viewport.scrollBy({
        left: direction * Math.max(viewport.clientWidth * 0.86, 240),
        behavior: 'smooth'
      });
    };

    const requestedMoment = new URLSearchParams(window.location.search).get('moment');
    const requestedMomentSlide = requestedMoment ? viewport.querySelector(`[data-jc-moment-group="${requestedMoment}"]`) : null;
    if (requestedMomentSlide) {
      root.dataset.jcActiveMoment = requestedMoment;
      window.requestAnimationFrame(() => {
        viewport.scrollTo({ left: Math.max(0, requestedMomentSlide.offsetLeft - 18), behavior: 'auto' });
        requestedMomentSlide.classList.add('is-jc-moment-target');
        window.setTimeout(() => requestedMomentSlide.classList.remove('is-jc-moment-target'), 1800);
      });
    }

    previous?.addEventListener('click', () => scrollByPage(-1));
    next?.addEventListener('click', () => scrollByPage(1));

    let dragStartX = 0;
    let dragStartScrollLeft = 0;
    let dragging = false;
    let dragged = false;

    const finishDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      if (event?.pointerId !== undefined && viewport.hasPointerCapture?.(event.pointerId)) {
        viewport.releasePointerCapture(event.pointerId);
      }
    };

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      dragged = false;
      dragStartX = event.clientX;
      dragStartScrollLeft = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture?.(event.pointerId);
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const distance = event.clientX - dragStartX;
      if (Math.abs(distance) > 4) {
        dragged = true;
        viewport.scrollLeft = dragStartScrollLeft - distance;
        event.preventDefault();
      }
    });

    viewport.addEventListener('pointerup', finishDrag);
    viewport.addEventListener('pointercancel', finishDrag);

    viewport.addEventListener('click', (event) => {
      if (dragged) {
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }
    }, true);

    viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollByPage(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollByPage(1);
      }
    });

    root.dataset.carouselInitialized = 'true';
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-moment-product-carousel]').forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
